export default __webpack_public_path__ + "static/media/foto@3x.5ba1e251.png";